import { ITemplate } from 'graphql/types';

export const CERTIFICATE_TEMPLATE_DATA = {
    [ITemplate.Modern]: 1,
    [ITemplate.Fresh]: 2,
    [ITemplate.Classic]: 3,
    [ITemplate.Split]: 4,
    [ITemplate.Custom]: 5,
    [ITemplate.AcademyModern]: 6,
    [ITemplate.AcademySplit]: 7,
};
